module.exports = __webpack_public_path__ + "static/img/bc-hawker.9a57af2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-hawker.png
// module id = OKUN
// module chunks = 0